module.exports = __webpack_public_path__ + "static/media/431185780_947994143555099_4701096013866828981_n.8dfad6c7.jpg";